/**
 * Full-width rich text block (acf.fullwidthtext.body).
 */

import { OpsiHtmlContent } from "../utils/OpsiHtmlContent";
import { hasHtmlContent, OPSI_PART_SPACING } from "../utils/opsiHelpers";

export const OpsiFullWidthText = ({
  data,
  className = `opsi-full-width-text ${OPSI_PART_SPACING}`,
}) => {
  const body = data?.body ?? data?.fullwidthtext?.body ?? "";

  if (!hasHtmlContent(body)) {
    return null;
  }

  return (
    <section className={className} data-opsi-part="fullwidthtext">
      <OpsiHtmlContent html={body} />
    </section>
  );
};
